import { Component, noDataDropDownRender, Position, PuzzleTagField } from "puzzle";
import {
  REMOTE_TAG_FIlTER_CHANGE,
  REMOTE_TAG_PROPS,
  REMOTE_TAG_RESPONSE_DATA,
  REMOTE_TAG_STATE,
  REMOTE_TAG_SUPPORTED_VALUES
} from "./Types";
import { ListItemProps, MultiSelectFilterChangeEvent } from "@progress/kendo-react-dropdowns";
import { get } from "lodash";
import React, { ReactElement } from "react";
import virtualScroll from "../../../VirtualScroll";
import * as _ from "lodash";

const initialPaginationData = {
  data: [],
  pageDataPopulated: [],
  pageNumber: 0,
  skip: 0,
  total: 0
};

export class RemoteTagField extends Component<REMOTE_TAG_PROPS, REMOTE_TAG_STATE> {
  gridRef: any;

  public state: REMOTE_TAG_STATE = {
    ...initialPaginationData,
    filter: '',
    initialDataFetched: false,
    requestInProgress: false,
    value: []
  };

  static defaultProps: REMOTE_TAG_PROPS = {
    pageSize: 10,
    requestActionName: 'getRemoteTagFieldValues',
    value: [],
    valuesProvider: ''
  };

  moduleDidMount = (): void => {
    super.moduleDidMount();

    const { value } = this.props;
    if (value && value.length) {
      let filter = value.join(' ');
      this.setState({ filter }, () => {
        this.setGridData({
          index: 0,
          size: 10,
          success: true,
          supportedValues: value.map((item: string) => {
            return { name: item, value: item }
          }),
          totalCount: value.length
        });
      });
    } else {
      this.dispatch(this.props.requestActionName, Position.end, this.prepareRequestParams(0));
    }
  };

  /**
   * Filter Change handler
   * @param event
   */
  filterChange = (event: REMOTE_TAG_FIlTER_CHANGE |  MultiSelectFilterChangeEvent): void => {
    const isInput = event.nativeEvent.type === 'input';
    this.setState({
      ...initialPaginationData,
      filter: event.filter.value
    }, () => {
      const delayFiltering = {
        buffer: isInput ? 300 : 1,
        pos: Position.end
      };
      this.dispatch(this.props.requestActionName, delayFiltering, this.prepareRequestParams(0));
    });
  };

  /**
   * Find current value in data
   * @param value
   * @param data
   */
  findValueInData = (value: string[], data: REMOTE_TAG_SUPPORTED_VALUES[]) => {
    let result = [];

    let i = 0;
    let valueLength = value.length;
    let current;
    let matchedItem;
    while (i < valueLength) {
      current = value[i];
      matchedItem = _.find(data, { value: current });
      if (matchedItem) {
        result.push(matchedItem);
      }
      i++;
    }

    return result;
  }

  /**
   * Check is first value item string
   * @param value
   */
  isValueItemsString = (value: any) => {
    let isString = value && value.length ? typeof value[0] === 'string' : false;

    return isString;
  }

  /**
   * If data still isn't loaded sets fake values.
   * Need to have all fields, prevent ListItem from breaking
   * @param data
   */
  prepareDataForDisplay = (data: any[]) => {
    let mappedData = data.map((item) => {
      if (!get(item, 'name')) {
        return {
          ...item,
          name: '',
          value: ''
        }
      } else return item
    });
    return mappedData;
  };

  /**
   * Prepare params for combo action request
   */
  prepareRequestParams = (pageNumber: number) => {
    const { filter } = this.state;
    const { valuesProvider, pageSize } = this.props;

    return {
      params: {
        nameFilter: filter,
        index: pageNumber,
        size: pageSize,
        valuesProvider
      }
    };
  };

  /**
   * Sets grid data (virtualScrolling)
   * @param data
   */
  setGridData = (data: REMOTE_TAG_RESPONSE_DATA) => {
    let { supportedValues = [] } = data;

    const repackedData = {
      gridContentInfo: {
        totalCount: data.totalCount
      },
      items: supportedValues
    };
    const { onChange, virtualScroll } = this.props;


    virtualScroll?.setGridData(repackedData);

    const { initialDataFetched, filter } = this.state;
    if (!initialDataFetched) {
      const { name, value } = this.props;
      if (value.length) {
        let fakeChangeEvent = {
          target: {
            value: this.findValueInData(value, supportedValues),
            name: name
          }
        }
        onChange && onChange(fakeChangeEvent);
      }

      this.setState({
        filter: '',
        initialDataFetched: true
      }, () => {
        if (filter) {
          let fakeEvent = {
            filter: { value: '' },
            nativeEvent: { type: '' }
          }
          // @ts-ignore
          this.filterChange(fakeEvent)
        }
      });
    }
  };

  /**
   * Render custom element for dropdown menu item
   */
  itemRender = (li: ReactElement<HTMLLIElement>, itemProps: ListItemProps): ReactElement => {
    const { name } = itemProps.dataItem;
    let textItem = name ? name : this.translate('loading');
    return React.cloneElement(
      li,
      {
        ...li.props,
        id: itemProps.id?.substr(7, itemProps.id?.length)
      },
      textItem
    );
  };

  render() {
    const { data, initialDataFetched, skip, total } = this.state;
    const fieldProps: any = _.pick(this.props, ['label', 'name', 'id', 'onChange', 'textField', 'value', 'valueField', 'pageSize'])
    const { pageSize } = this.props;
    let displayData: any[] = data.slice(skip, skip + pageSize);
    displayData = this.prepareDataForDisplay(displayData);

    if (!initialDataFetched) {
      fieldProps.value = [];
    } else if (this.isValueItemsString(fieldProps.value)) {
      fieldProps.value = this.findValueInData(fieldProps.value, data);
    }
    return (
      <PuzzleTagField
        {...fieldProps}
        autoClose={false}
        data={displayData}
        filterable={true}
        listNoDataRender={() => noDataDropDownRender(this.translate('searching'))}
        onFilterChange={this.filterChange}
        onPageChange={this.props.virtualScroll?.pageChange}
        popupSettings={{ className: `${this.props.zIndexCls} tp-multiselect-dropdown-list` }}
        ref={(el: any) => this.gridRef = el}
        virtual={{
          pageSize: pageSize,
          skip: skip,
          total: total
        }}
        remoteTagField
      />
    );
  }
}

export default virtualScroll(RemoteTagField);
